"use client";
import { getCookie } from "cookies-next/client";
import { UTM_COOKIE_NAME } from "@/constants/utm";

export function parseUTMParameters(): Array<[string, string]> {
  const rawParameters = getCookie(UTM_COOKIE_NAME);

  if (!rawParameters || typeof rawParameters !== "string") return [];

  try {
    return JSON.parse(rawParameters);
  } catch {
    return [];
  }
}
